import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { RaceDTO } from "../../interfaces/RaceDTO";
import { TimeDTO } from "../../interfaces/TimeDTO";
import { GetHeatName } from "../results/resultviews/ResultStage";
import DisplayResultRow from "./DisplayResultRow";
import style from "./styles/displaystyle.module.css";
import { useDisplays } from "../../services/displayservices/DisplayProvider";
import { eventBus } from "../../services/eventHandler";
import moment from "moment";
interface SelectedClassLevel {
  classID: number;
  level: number;
  ipos: number;
}

interface Props {
  race: RaceDTO;
  scroll: { [key: number]: TimeDTO };
  resultmode: (isResult: boolean) => void;
}

const DisplayResults = ({ race, resultmode, scroll }: Props) => {
  const {display,getDisplays,getDisplayProperty} = useDisplays();
  const [scrollLines, setScrollLines] = useState<TimeDTO[]>([]);
  const [resultLines, setResultLines] = useState<TimeDTO[]>([]);
  const [updatedResult,setUpdatedResults] = useState<number>(0);
  const [isResultMode,setIsResultMode] = useState<boolean | null>(null);
  const [selectedClass, setSelectedClass] = useState<SelectedClassLevel | null>(
    null
  );
  const scrollLinesRef = useRef<TimeDTO[]>([]);
  const selectedClassRef = useRef<SelectedClassLevel | null>(null);

  useEffect(() => {
    let intervalId: any;
    const maxKey = Math.max(...Object.keys(scroll).map(Number));
    const handlerTime = (_time: TimeDTO | number) => {
      if (typeof _time === 'number') { //Om det är nummer så är det delete händer inte så ofta då kan vi köra rutinen 
        setUpdatedResults(prev => prev +1);
        // return 'number';
      } else if (typeof _time === 'object' && _time !== null) {
        let selClass:SelectedClassLevel = {
          classID: _time.ClassID,
          level: _time.Level,
          ipos: 999,
        };
        if (selectedClassRef.current){
          if (selectedClassRef.current.classID !== selClass.classID || selectedClassRef.current.level !== selClass.level){
            setSelectedClass(selClass);
          }
        }
        else{
          setSelectedClass(selClass);
        }
        setUpdatedResults(prev => prev +1);
        // return 'object';
      } else {
        // return 'neither';
      }
    }
    if (Object.keys(scroll).length > 0){
      let selClass:SelectedClassLevel = {
        classID: scroll[maxKey].ClassID,
        level: scroll[maxKey].Level,
        ipos: 999,
      };
      selectedClassRef.current = selClass;
      setSelectedClass(selClass);
    }
    
    intervalId = setInterval(() => {
      checkLastPass();
    },1000*10);
    eventBus.on(
      `tim_new`,
      handlerTime
    );
    checkLastPass();
    return () => {
      // Cleanup to avoid memory leaks
      if (intervalId) {
        clearInterval(intervalId);
      }
      eventBus.removeListener(
        `tim_new`,
        handlerTime
      );
    }


  }, []);
  useEffect(() => {
    selectedClassRef.current = selectedClass;
    if (selectedClass === null) {
      return;
    }
    let resultlines:number | null = getDisplayProperty("ResultLines");
    let scrolllines:number | null = getDisplayProperty("ScrollLines");

    let Passes =
      race.Class[selectedClass.classID].Level[selectedClass.level].TimePos[
        selectedClass.ipos
      ].TimePass;
    let timePasses: TimeDTO[] = [];
    // hämtar resultat
    Passes.map((tim, ind) => {
      if (ind > (resultlines === null ? 0 : (resultlines -1))) {
        return false;
      }
      timePasses.push(tim);
    });
    setResultLines(timePasses);

    //Vi hämtar alla keys som har ipos 999
    const filteredKeys = Object.keys(scroll).filter(
      (key) => scroll[parseInt(key)].Ipos === 999
    );

    ///Tar ut topp 3 för scroll 
    const sortedKeys = filteredKeys
      .map(Number)
      .sort((a, b) => b - a)
      .slice(0, (scrolllines === null ? 0 : (scrolllines)));

    let scrollPasses: TimeDTO[] = [];
    sortedKeys.map((timid) => {
      scrollPasses.push(scroll[timid]);
    });

    setScrollLines(scrollPasses);
    checkLastPass();
  }, [selectedClass,display,updatedResult]);

  useEffect(() => {
    scrollLinesRef.current = scrollLines;
     checkLastPass();
  },[scrollLines])

  const getClassStyle = ():CSSProperties =>{
    let showClass = getDisplayProperty("ShowResultClassName");
    let fontClass = getDisplayProperty("FontSizeHeader");
    let color = getDisplayProperty("TextColor");
    let cs:CSSProperties ={

    }
    if (showClass !== null && fontClass !== null){
      cs ={
        fontSize: fontClass + "px",
        display: showClass ? undefined : "none",
        color: color,
      }
    }

    return cs;
  };

  const getBorderStyle = ():CSSProperties =>{
    let height = getDisplayProperty("ResultBorderHeight");
    let color = getDisplayProperty("ResultBorderColor");
    let cs:CSSProperties ={
      borderBottomWidth:  height + "px",
      borderBottomColor: color,
    }
    return cs;
  };

  const checkLastPass = () => {
    if (scrollLinesRef.current.length < 1)
    {
      console.log("No scroll lines",scrollLinesRef.current);
      if (isResultMode === null){
        setIsResultMode(false);
        resultmode(false);
      }
      else if (isResultMode){
        setIsResultMode(false);
        resultmode(false);
      }
      return;
    }
    let dur = moment.duration(moment().diff(moment( scrollLinesRef.current[0].PassTime)));
    let resMode:boolean = true;
    console.log(dur.asSeconds());
    if (dur.asSeconds() > (60 * 10)){
      resMode = false;
    }
    
    // if (isResultMode === null){
      setIsResultMode(prev => resMode);
      resultmode(resMode);
    // }
    // else if (isResultMode != resMode){
    //   setIsResultMode(resMode);
    //   resultmode(resMode);
    // }
    
  }

  if (selectedClass === null) {
    return <></>;
  }

  return (
    <div className={style.displayresult}>
      <div className={style.displayclass} style={getClassStyle()}>
        {race.Class[selectedClass.classID].Name + " "}
        {selectedClass.level > 2 ? GetHeatName(selectedClass.level) : null}
      </div>
      <div className={style.displayresultbox} style={getBorderStyle()}>
      <table>
        <tbody>
          {resultLines.map((ti) => (
            <DisplayResultRow
              key={ti.ID + "-res-" + ti.Startno}
              time={ti}
              isResult={true}
              timeformat={race.Class[ti.ClassID].TimeFormat}
              athlete={
                race.Class[ti.ClassID].Level[ti.Level].Athletes[ti.Startno]
              }
            />
          ))}
        </tbody>
      </table>
      </div>
      <div className={style.displayscrollbox}>
        <table>
          <tbody>
            {scrollLines.map((ti) => (
              <DisplayResultRow
                key={ti.ID + "-scr-" + ti.Startno}
                time={ti}
                isResult={false}
                timeformat={race.Class[ti.ClassID].TimeFormat}
                athlete={
                  race.Class[ti.ClassID].Level[ti.Level].Athletes[ti.Startno]
                }
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DisplayResults;
